import validate from 'validate.js';

const validateBaseRate = (values) => {
  const { day_rate_discount: dayRateDiscount = {} } = values;

  return {
    day_rate_discount: {
      value: validate.single(Number(dayRateDiscount.value),
        {
          numericality: {
            lessThan: 51
          }
        })
    }
  };
};

export default validateBaseRate;
